import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBook,
  faBuilding,
  faDigitalTachograph,
  faHeartPulse,
  faLaptop,
  faMoneyBill,
  faPiggyBank,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
import industriesData from "../../JsonFiles/Industries.json";
import "./Industries.css";

const ICONS = {
  faBook,
  faMoneyBill,
  faHeartPulse,
  faPiggyBank,
  faDigitalTachograph,
  faBuilding,
  faLaptop,
  faTruck,
};

const ScrollLink = ({ to, children, ...props }) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <RouterLink to={to} onClick={handleClick} {...props}>
      {children}
    </RouterLink>
  );
};

const Industries = ({ id = "industries" }) => {
  const displayedIndustries = industriesData.slice(0, 8);

  return (
    <section
      id={id}
      className="industries-section"
      aria-labelledby="industries-title"
    >
      <div className="industries-section__decoration" aria-hidden="true" />

      <div className="industries-section__container">
        <header className="industries-section__header">
          <div>
            <p className="industries-section__eyebrow">
              <span aria-hidden="true" />
              Industry expertise
            </p>

            <h2 id="industries-title" className="industries-section__title">
              Technology shaped around
              <span> how your industry works.</span>
            </h2>
          </div>

          <div className="industries-section__header-side">
            <p>
              We combine technology expertise with an understanding of
              sector-specific operations, helping clients improve efficiency,
              visibility, and competitive advantage.
            </p>

            <ScrollLink
              className="industries-section__all-link"
              to="/industries"
            >
              Explore all industries
              <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
            </ScrollLink>
          </div>
        </header>

        <div className="industries-section__grid">
          {displayedIndustries.map((industry, index) => {
            const icon = ICONS[industry.icon] ?? faBuilding;

            return (
              <article key={industry.id} className="industries-section__card">
                <ScrollLink
                  className="industries-section__card-link"
                  to={`/industries/${industry.id}`}
                  aria-label={`Explore solutions for ${industry.title}`}
                >
                  <div className="industries-section__card-top">
                    <span
                      className="industries-section__icon"
                      aria-hidden="true"
                    >
                      <FontAwesomeIcon icon={icon} />
                    </span>

                    <span
                      className="industries-section__number"
                      aria-hidden="true"
                    >
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>

                  <div className="industries-section__card-content">
                    <h3>{industry.title}</h3>
                    <p>{industry.description}</p>
                  </div>

                  <span className="industries-section__card-action">
                    View industry expertise
                    <span aria-hidden="true">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </span>
                </ScrollLink>
              </article>
            );
          })}
        </div>

        <aside
          className="industries-section__cta"
          aria-label="Discuss another industry"
        >
          <div>
            <span>Your sector is not listed?</span>
            <p>Our solutions adapt to the way your organization operates.</p>
          </div>

          <ScrollLink className="industries-section__cta-link" to="/contact">
            Discuss your requirements
            <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
          </ScrollLink>
        </aside>
      </div>
    </section>
  );
};

export default Industries;
